import { routerRedux } from 'dva/router';
import { Model } from 'dva';
import { sendCMABusinessError, sendCMATechError } from '../helpers/CMAstats';
import { getProfileWithLogin } from '../helpers/getProfileWithLogin';

const USER_TYPE_INDIVIDUAL = 'individual';

export const xCallerId = 'ums::service';
export const serviceID = 'ums';
export const DEFAULT_FETCH_OPTIONS: RequestInit = {
  mode: 'same-origin',
  credentials: 'include',
  headers: {
    'x-caller-id': xCallerId,
  },
};

const auth: Model = {
  namespace: 'auth',
  reducers: {
    set(state, { payload }) {
      return Object.assign(state, payload);
    },
  },
  effects: {
    *getUserAuth(_, { put, call }) {
      try {
        const response = yield call(getProfileWithLogin);
        const {
          person_type: personType,
          first_name,
          last_name,
          middle_name,
        } = response;

        const status = {
          name: first_name,
          surname: last_name,
          patronymic: middle_name,
        };

        if (response.status === 401) return;
        if (personType !== USER_TYPE_INDIVIDUAL) {
          sendCMABusinessError('start');
          yield put(
            routerRedux.push({
              pathname: '/error/',
              state: {
                status: 'error',
                statusName: 'juridical',
              },
            })
          );
          return;
        }
        yield put({
          type: 'set',
          payload: { status },
        });
        yield put({
          type: 'elk/getBlocks',
        });
      } catch (error) {
        console.error(error);
        sendCMATechError('start');
        yield put(
          routerRedux.push({
            pathname: '/error/',
            state: {
              status: 'error',
              statusName: 'serviceNotAvailable',
            },
          })
        );
      }
    },
  },
};

export default auth;
